var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMoWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 14,
    viewBox: "0 0 184 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_15467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1793 0.196289H25.1748V13.8346H27.1793V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1966 5.99805L27.9619 7.01527L32.1966 8.03249V5.99805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2953 0.196289H28.1914C31.0534 0.584341 32.9075 1.33407 34.2953 2.46809V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5153 0.196289H37.5107V13.8346H39.5153V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6534 13.8341L42.3581 5.72266L41.0117 7.07142L45.4232 13.8341H47.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7205 0.196289C44.7205 0.196289 44.5249 2.02729 43.2236 4.85668L47.8758 0.196289H44.7242H44.7205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2953 11.5059C32.9075 12.6436 31.0534 13.4461 28.1914 13.8342H34.2953V11.5059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.233 0.196289H162.229V13.8346H164.233V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.173 0.196289H164.85C168.674 0.546666 170.818 3.21405 170.818 7.00792C170.818 10.8018 168.697 13.4842 164.85 13.8346H166.173C169.942 13.8346 172.954 11.0165 172.954 7.00792C172.954 2.9993 170.119 0.196289 166.173 0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.333 0.196289H149.332V13.8308H151.333V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.667 3.61717C158.667 0.557968 155.301 0.196289 154.225 0.196289H152.42C153.123 0.343221 156.542 0.719971 156.542 3.63224C156.542 7.23773 152.589 7.35452 152.589 7.35452C153.251 7.35452 153.872 7.6823 154.248 8.22858C156.444 11.4498 155.214 9.64516 157.824 13.8233H160.156L155.842 7.28671C157.072 7.01168 158.667 5.85129 158.667 3.62094V3.61717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.261 2.88197C176.261 1.63869 177.088 0.644076 178.57 0.12793C176.37 0.184442 174.587 1.54074 174.587 3.49607C174.587 8.80446 182.289 6.04289 182.289 10.5563C182.289 12.0859 181.462 13.3292 179.679 13.9056C182.158 13.8491 184 12.2027 184 9.82922C184 4.42287 176.261 7.09402 176.261 2.88573V2.88197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.285 2.95355V0.320072C182.533 0.331374 180.701 0.256024 179.848 0.12793C179.848 0.12793 182.07 0.632774 183.285 2.95355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.549 10.9971V13.7134L178.306 13.9056C176.049 13.2237 175.113 11.7129 174.549 10.9971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.378 12.7307L136.045 0.196289H134.014L131.378 12.7307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.102 0.196289L125.748 2.24957L123.763 12.9078L126.67 5.16561L129.4 13.8346H131.48L127.204 0.196289H125.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.967 0.196289L121.807 13.8346H123.909L119.047 0.196289H116.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00454 0.196289H0V13.8346H2.00454V0.196289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92742 3.66154C6.92742 6.8074 3.46743 6.99954 2.93339 7.01838C3.51256 7.01084 7.41633 7.01838 7.41633 10.3677C7.41633 13.717 3.01237 13.8338 2.80928 13.8338H4.26849C8.34902 13.8338 9.52617 12.2288 9.52617 10.3187C9.52617 8.65724 8.41296 7.32731 5.50205 6.99201C7.70216 6.58888 8.93572 5.30417 8.93572 3.71429C8.93572 1.80417 7.49155 0.199219 4.26849 0.199219H2.80176C3.50504 0.334848 6.92366 0.489315 6.92366 3.66531L6.92742 3.66154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.875 13.8346L76.9693 0.196289H74.6338L83.5395 13.8346H85.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0371 13.8338H78.2752C76.2594 12.4285 75.0371 7.01465 75.0371 7.01465V13.8338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.492 7.01545V0.196289H82.2539C84.2697 1.60156 85.492 7.01545 85.492 7.01545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3959 13.3072V7.01172H95.4658C95.4658 7.01172 97.4892 7.64089 97.4892 9.71678V13.326C97.7938 13.2507 98.8732 13.0246 99.3959 13.3072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2067 13.6948C92.5511 13.9284 90.1065 11.5511 90.1065 6.85684C90.1065 3.3493 91.1107 0.738428 94.1043 0C90.43 0 87.7598 3.07804 87.7598 7.0113C87.7598 12.0748 91.8704 14.9795 96.2067 13.6948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3127 2.8746V0.19591C98.5342 0.207212 96.6387 0.128095 95.7549 0C95.7549 0 98.3649 0.678149 99.3127 2.8746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1846 11.0234V13.7586L53.9417 13.9508C51.6851 13.2613 50.7487 11.743 50.1846 11.0234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9218 2.92356V0.271244C58.1696 0.282546 56.3381 0.207196 55.4844 0.0791016C55.4844 0.0791016 57.707 0.587713 58.9218 2.92356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8923 2.85588C51.8923 1.60507 52.7197 0.602922 54.2015 0.0830078C52.0014 0.13952 50.2188 1.50712 50.2188 3.47375C50.2188 8.81982 57.921 6.03941 57.921 10.583C57.921 12.1239 57.0936 13.3785 55.311 13.9549C57.7894 13.8984 59.6322 12.2407 59.6322 9.85211C59.6322 4.40809 51.8923 7.09808 51.8923 2.85965V2.85588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1411 3.15723L10.7334 13.8343H13.1592L15.1411 3.15723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1766 10.0219L20.5343 13.8346H22.6366L17.7738 0.196289H15.6715L18.6464 8.54128L15.3594 9.22697L19.1766 10.0219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2173 3.15723L60.8096 13.8343H63.2353L65.2173 3.15723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2528 10.0219L70.6105 13.8346H72.7128L67.85 0.196289H65.7477L68.7225 8.54128L65.4355 9.22697L69.2528 10.0219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.103 0.196289L113.082 8.54128L109.791 9.22697L113.608 10.0219L114.966 13.8346H117.068L112.205 0.196289H110.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.591 13.8343L109.573 3.15723L105.165 13.8343H107.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.363 0.196289L143.342 8.54128L140.051 9.22697L143.868 10.0219L145.226 13.8346H147.328L142.465 0.196289H140.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.851 13.8343L139.833 3.15723L135.425 13.8343H137.851Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_15467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMoWh);
export default __webpack_public_path__ + "static/media/logo_mo_wh.e8c6e3896c7681974a3f45aec2e9ba55.svg";
export { ForwardRef as ReactComponent };